import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import ItemsCarousel from 'react-items-carousel';
import moment from 'moment';
import Button from '../helpers/Button';

const AvailableProduct = ({ title, products }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  const history = useHistory();
  const chevronWidth = 40;

  return (
    <div className="farms-bg pt-40">
      <div className="mx-auto md:w-1/2 flex flex-col items-center justify-center">
        <h2>You have no {title} yet.</h2>
        <p className="text-2xl">Get started with these crop(s)</p>
        <div style={{ padding: `0 ${chevronWidth}px` }} className="w-full mt-5">
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            leftChevron={<IoIosArrowBack size={chevronWidth} />}
            rightChevron={<IoIosArrowForward size={chevronWidth} />}
            outsideChevron
            chevronWidth={chevronWidth}
          >
            {products.map(product => (
              <div key={product._id} className="flex md:mt-5 justify-center">
                <img
                  className="md:w-56 md:h-48 mr-5 w-32 h-32"
                  src={product.crop && product.crop.imageUrl}
                  alt={product.crop && product.crop.name}
                />
                <div className="float-right md:float-none">
                  <h6 className="mb-4">{product.crop && product.crop.name}</h6>
                  <ul className="text-tiny md:text-lg mb-4">
                    <li>
                      <b>Starts On:</b>
                      {moment(product.startDate).format('L')}
                    </li>
                    <li>{product.acreage} acreage left</li>
                    <li>{product.projectedReturnsPerAcre}% Project Returns</li>
                    <li>
                      <b>Duration:</b> {product.duration} Months
                    </li>
                  </ul>

                  <Button
                    click={() =>
                      history.push({
                        pathname: '/start-farm',
                        state: { step: 1, product }
                      })
                    }
                    className="bg-cf-300 text-white text-xs px-2 py-3 md:text-lg md:px-10 md:py-4 rounded"
                    name="Start A Farm"
                  />
                </div>
              </div>
            ))}
          </ItemsCarousel>
        </div>
      </div>
    </div>
  );
};

export default AvailableProduct;
